import { Injectable } from '@angular/core';
import { PatientCodelistItem } from '../../domain/models/patient-codelist-item.model';
import { CodelistItemDto } from '../dtos/codelist-item.dto';

@Injectable({ providedIn: 'root' })
export class PatientCodelistMapper {
  // `CodelistItemDto.Id`/`ParentId` are strings (this codebase's universal external-id
  // convention), but `PatientDto.SpeciesId`/`BreedId` are numeric -- parsed here so
  // `speciesById.get(patient.speciesId)`-style lookups type-check and actually match.
  public toPatientCodelistItem(dto: CodelistItemDto): PatientCodelistItem {
    return {
      id: Number(dto.Id),
      label: dto.Label,
      masterCode: dto.MasterCode ?? null,
      parentId: dto.ParentId ? Number(dto.ParentId) : null,
    };
  }
}
